export default {
  resourceName(state) {
    return state.resource.label.toUpperCase();
  }
};
